import React from 'react';
import reactDom from 'react-dom';
import closeIcon from '../../assets/images/closebtn.svg';

export default function CancelBooking(props) {
    return reactDom.createPortal(
        <div class="modal">
			<div class="modal-content">
				<div class="modal-body">
                    <div className="generate-popup">
                        <span onClick={() => props.setCancelBook(false)}><img src={closeIcon}/></span>
                        <div style={{margin: '20px 10px;'}} className="img-circle">
                            <p>Are you sure you want to cancel your booking for slot : {props.item.slot.slotNumber} ?</p>
                            <div className="buttons-wrapper">
                                <div className="comman-btn">
                                    <button onClick={() => {
                                        props.handleCancelBooking(props.item)
                                    }}>Yes, cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
    ,document.body)
}
